import { render } from "./MerchantMultiselect.vue?vue&type=template&id=bf90217a&ts=true"
import script from "./MerchantMultiselect.vue?vue&type=script&lang=ts"
export * from "./MerchantMultiselect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__